import angular from 'angular';
import uiRouter from 'angular-ui-router';
import attendanceComponent from './attendance.component';
import attendanceListComponent from './attendance-list.component';
import attendanceDetailComponent from './attendance-detail.component';
import attendanceService from './attendance.service';

let attendanceModule = angular.module('attendance', [
  uiRouter
])

.service('Attendance', attendanceService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/attendance');

  $stateProvider
    .state('attendance', {
      component: 'attendance'
    })
    .state('attendance.list', {
      url: '/attendance',
      component: 'attendanceList'
    })
    .state('attendance.create', {
      url: '/attendance/new',
      component: 'attendanceDetail',
      params: {
      	id: ""
      }
    })
    .state('attendance.show', {
      url: '/attendance/:id',
      component: 'attendanceDetail',
      params: {
        id: ""
      }
    });
})

.component('attendance', attendanceComponent)
.component('attendanceList', attendanceListComponent)
.component('attendanceDetail', attendanceDetailComponent)

.name;

export default attendanceModule;



// WEBPACK FOOTER //
// ./client/app/components/attendance/attendance.js